import { initMainHeader } from '../js/src/header-init';
import { loadCSS, replaceGMapLink, Utils } from "../js/src/utils";
import WOW from 'wow.js';
import '../scss/pages/tech-summit.scss';

initMainHeader();
replaceGMapLink();
if (window.innerWidth > Utils.screen.sm) {
    loadCSS('build/assets/css/animate.min.css');
    setTimeout(() => (new WOW({ offset: 100, live: false, mobile: false })).init(), 200);
}


global.scrollToEventRecap = () => {
    const sponsorSection = document.querySelector('#event_recap');

    if (sponsorSection) {
        const headerOffset = 190;
        const elementPosition = sponsorSection.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }
}

const initScrollEvent = () => {
    if (window.innerWidth > Utils.screen.xs) {
        document.body.classList.remove('down');
        lastPos = 0;
        window.removeEventListener('scroll', onScroll);
        return
    }

    window.addEventListener('scroll', onScroll, { passive: true });
};

let lastPos = 0;
const diff = 100;
const onScroll = () => {
    const currPos = window.scrollY || document.documentElement.scrollTop;
    const cl = document.body.classList;

    if (currPos > lastPos + diff) {
        cl.add('down');
        lastPos = currPos;
    } else if (currPos < lastPos - diff) {
        cl.remove('down');
        lastPos = currPos;
    }
}

window.addEventListener('resize', initScrollEvent);
initScrollEvent();
